import { useEffect, useState } from "react";
import { BookOpen, RefreshCw, KeyRound, Loader2, AlertTriangle } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { dtt } from "./shared";

const Novita = ({ n }) => {
  if (!n) return null;
  if (n.primo_import) return <p className="text-neutral-500">Primo import completato il {dtt(n.at)}.</p>;
  const parts = [["nuovi", n.nuovi], ["aggiornati", n.aggiornati], ["rimossi", n.rimossi]].filter(([, l]) => l?.length);
  return (
    <details className="text-neutral-400" data-testid="docs-novita">
      <summary className="cursor-pointer">Ultime novità ({dtt(n.at)}): {parts.map(([k, l]) => `${l.length} ${k}`).join(", ")}</summary>
      {parts.map(([k, l]) => <div key={k} className="mt-1"><b className="capitalize text-neutral-300">{k}:</b> {l.join(" · ")}</div>)}
    </details>
  );
};

export function DocsPanel() {
  const { user } = useAuth();
  const [s, setS] = useState(null);
  const [pwd, setPwd] = useState("");
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/monitoring/docs-status").then((r) => setS(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  useEffect(() => { if (s?.running) { const t = setTimeout(load, 4000); return () => clearTimeout(t); } }, [s]);
  const sync = async () => { try { await api.post("/monitoring/docs-sync"); setS((x) => ({ ...x, running: true })); } catch (e) { toast.error(e.response?.data?.detail || "Errore"); } };
  const save = async () => {
    setBusy(true);
    try { await api.put("/monitoring/docs-password", { password: pwd }); setPwd(""); toast.success("Accesso a torri.solar verificato: aggiornamento documenti avviato"); setS((x) => ({ ...x, running: true, error: null })); }
    catch (e) { toast.error(e.response?.data?.detail || "Password non valida"); }
    setBusy(false);
  };
  if (!s) return null;
  const err = s.error || (!s.password_impostata ? "Accesso a torri.solar non configurato: inserisci la password dell'Area Clienti" : null);
  return (
    <div className={`space-y-2 rounded-xl border p-3 text-xs ${err ? "border-red-500/50 bg-red-500/[0.06]" : "border-neutral-800 bg-neutral-950"}`} data-testid="docs-panel">
      <div className="flex flex-wrap items-center gap-3">
        <BookOpen className="h-4 w-4 text-neutral-400" />
        <span className="font-bold text-neutral-200">Manuali torri.solar</span>
        <span className="text-neutral-400" data-testid="docs-status">{s.running ? <span className="inline-flex items-center gap-1"><Loader2 className="h-3.5 w-3.5 animate-spin" />Controllo documenti in corso…</span>
          : s.last_ok ? `Ultimo controllo riuscito ${dtt(s.last_ok)} · ${s.n_docs} documenti · ${s.n_manuali || 0} manuali con tabella allarmi` : "Mai sincronizzato"}</span>
        {s.password_impostata && <button type="button" onClick={sync} disabled={s.running} data-testid="docs-sync-btn" className="ml-auto inline-flex items-center gap-1 rounded-full border border-neutral-700 px-3 py-1 font-bold text-neutral-200 hover:border-neutral-400 disabled:opacity-40"><RefreshCw className="h-3.5 w-3.5" />Aggiorna ora</button>}
      </div>
      {err && !s.running && <p className="flex items-center gap-1.5 font-semibold text-red-400" data-testid="docs-error"><AlertTriangle className="h-4 w-4" />{err}{s.error_at ? ` (${dtt(s.error_at)})` : ""}</p>}
      {user?.role === "admin" && (err || !s.password_impostata) && (
        <div className="flex flex-wrap items-center gap-2" data-testid="docs-password-form">
          <KeyRound className="h-4 w-4 text-neutral-400" />
          <input type="password" value={pwd} onChange={(e) => setPwd(e.target.value)} placeholder="Nuova password Area Clienti torri.solar" autoComplete="new-password"
            className="w-72 rounded-full border border-neutral-700 bg-transparent px-3 py-1 text-white outline-none placeholder:text-neutral-600" data-testid="docs-password-input" />
          <button type="button" onClick={save} disabled={!pwd || busy} data-testid="docs-password-save" className="rounded-full bg-white px-3 py-1 font-bold text-black disabled:opacity-40">{busy ? "Verifica…" : "Verifica e salva"}</button>
        </div>
      )}
      <Novita n={s.ultime_novita} />
    </div>
  );
}
